import React from "react";
import { useNavigate } from "react-router-dom";
import headerLogo from "../../assets/icons/full-logo-bw.png";
import ProfileDropdown from "./ProfileDropdown";
import NotificationDropdown from "./NotificationDropdown";
import { confirmDialog } from "../../utils/confirmDialog";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const confirmation = await confirmDialog(
      "Are you sure you want to log out?",
      "Confirm Logout",
      {
        type: "danger",
        confirmText: "Logout",
        cancelText: "Cancel"
      }
    );

    if (confirmation) {
      navigate("/");
      localStorage?.clear();
    }
  };

  return (
    <header className="bg-gradient-to-r from-[#1a4a4a] to-[#042929] text-white shadow-md">
      <div className="mx-auto px-6 py-3 flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <img
            src={headerLogo}
            alt="Company Logo"
            className="h-10 hover:opacity-90 transition-opacity cursor-pointer"
            onClick={() => navigate('/dashboard')}
          />
        </div>

        {/* Navigation Controls */}
        <div className="flex items-center space-x-6">
          {/* Notification Bell */}
          <div className="relative">
            <NotificationDropdown />
          </div>

          {/* Profile Dropdown */}
          <div className="relative">
            <ProfileDropdown logout={handleLogout} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;